const thankYou = {
    title: 'Dankjewel!',
    tagLine_q: 'Dankjewel voor het stellen van je vraag! ',
    tagLine_a: 'Dankjewel voor het aanmelden! Vul de calender in om gelijk een afspraak te maken met mij!',
    button: 'GA TERUG NAAR DE SITE'
}
export default thankYou;